<template>
	<div class="tpl add-gift-wrap">
		<mt-header title="补充礼物" fixed>
		  <router-link :to="{name:'add-gift',query:{id:aid}}" slot="left">
		    <mt-button icon="back"></mt-button>
		  </router-link>
		</mt-header>
		<div class="gift-list" v-if="giftList != undefined||null||''">
			<p class="title">礼物详情</p>
			<ul>
				<li v-for="item in giftList">
					<div class="item-left">
						<img :src="item.gimg" alt="" />
						<div>
							<span class="item-name">{{item.gname}}</span>
							<p class="item-num">&times;{{item.gnum}}</p>
						</div>
					</div>
					<div class="item-price">
						{{item.gnum*item.gprice}}桃花币
					</div>
				</li>
			</ul>
			<p class="cul">小计: <span class="num">{{totlePrice}}</span><span class="per">桃花币</span></p>
		</div>
		<div class="no-content" v-else>
			<img src="../../assets/img/default/bg_img_empty@2x.png"/>
			<p>请返回上一页重新选择~</p>
		</div>
		<div class="submit-btn">
			<button @click="nextStep">下一步</button>
		</div>
		<transition name="fade">
		<div class="upper-wrap pay-wrap" v-if="showPayBox" @click.self="showPayBox=0">
			<div class="upper-inner pay-inner">
				<p class="title">支付礼物</p>
				<div class="pay-content upper-content">
					<div class="pay-num">
						<span class="num">{{totlePrice}}</span>
						<span class="per">桃花币</span>
					</div>
					<div class="pay-type">
						<span class="name">约会礼物</span>
						<span class="value">账户支付</span>
					</div>
				</div>
				<div class="pay-btns">
					<button class="cancel" @click="showPayBox=0">取消</button>
					<button class="sure" @click="submitPay">确定</button>
				</div>
			</div>
		</div>
		</transition>
	</div>
</template>

<script>
	export default{
		name:"add-gift-cul",
		data(){
			return{
				uid:"",
				aid:"",	//当前约会id
				giftList:"",
				showPayBox:0,
				giftData:""
			}
		},
		computed:{
			totlePrice(){
				let price = 0;
				this.giftList.map(item=>{
					price += (item.gnum*item.gprice);
				})
				return price;
			}
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed","finds");		//属于finds模块
			this.$store.commit("changeTabBarShow",false);	//不显示navbar
			
			this.aid = this.$route.query.id;
			this.giftList = this.$route.params.gift
			
			console.log(this.giftList);
		},
		methods:{
			nextStep(){
				let gifts = "";
				this.giftList.map(item=>{
					gifts+=(item.gid+","+item.gnum+",")
				})
				console.log(gifts.slice(0,gifts.length-1));
				this.giftData = gifts.slice(0,gifts.length-1);
				
				this.showPayBox = 1;
			},
			submitPay(){
				this.showPayBox=0;
				console.log(this.giftData);
				this.$axios({
					url:"Appointment/addgift",
					method:"post",
					data:{
						uid:this.uid,
						r_id:this.aid,
						gift:this.giftData
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.$toast({
							message:res.data.msg,
							position:"bottom",
							duration:3000
						});
					}else if(res.data.code == 300||201){
						this.$toast({
							message:res.data.msg,
							position:"bottom",
							duration:3000
						});
					}
				}).catch(err=>{
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped>
	.add-gift-wrap{
		padding-top: 2.5rem;
		padding-bottom: 4rem;
	}
	.gift-list{
		margin: 1rem;
		background: #fff;
		border-radius: 5px;
		box-shadow:0px 5px 10px 0px rgba(40,40,56,0.08);
	}
	.gift-list .title{
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
		padding: 0.5rem 1rem;
		border-bottom: 1px solid #f3f3f3;
	}
	.gift-list ul{
		padding: 0.5rem 1rem;
	}
	.gift-list li{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.5rem 0;
	}
	.gift-list li .item-left{
		display: flex;
		justify-content:flex-start;
		align-items: center;
	}
	.gift-list .item-left img{
		width: 3.2rem;
		margin-right: 0.5rem;
	}
	.gift-list .item-left>div{
		padding-top: 0.5rem;
	}
	.gift-list .item-left .item-name{
		background: rgba(255,97,97,.7);
		border-radius: 4px;
		padding: 0.2rem 0.5rem 0.1rem;
		font-size: 0.8rem;
		color: #fff;
	}
	.gift-list .item-left .item-num{
		font-size: 0.65rem;
		color: #7b7b7b;
		line-height: 1rem;
		padding: 0.3rem 0;
	}
	.gift-list .item-price{
		font-size: 0.8rem;
		color: #282828;
	}
	.gift-list .cul{
		font-size: 0.8rem;
		color: #282828;
		text-align: right;
		padding: 0.5rem 1rem;
		border-top: 1px solid #f3f3f3;
	}
	.gift-list .cul .per{
		color: #282828;
	}
	.gift-list .cul .num{
		font-size: 1.2rem;
		color: #282828;
		font-weight: bold;
	}
	
	.submit-btn{
		position: fixed;
		width: 100%;
		padding: 0.5rem 1rem;
		background: #fff;
		bottom: 0;
		left: 0;
	}
	.submit-btn button{
		width: 100%;
		height: 2.8rem;
		font-size: 1rem;
		color: #fff;
		background:linear-gradient(90deg,rgba(135,91,251,1) 0%,rgba(203,184,253,1) 100%);
		border: 0;
		border-radius: 3px;
		outline: 0;
	}
	
	.upper-wrap{
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 10;
		display: flex;
		justify-content: flex-end;
		flex-direction: column;
		align-items: center;
		background: rgba(0,0,0,.3);
	}
	.upper-inner{
		background: #fff;
		border-radius: 1rem 1rem 0 0;
		width: 100%;
	}
	.upper-inner .title{
		font-size: 1rem;
		color: #282828;
		font-weight: bold;
		text-align: center;
		padding: 0.5rem;
		border-bottom: 1px solid #f3f3f3;
	}
	.upper-content{
		min-height: 15rem;
	}
	
	.pay-content{
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		text-align: center;
		padding-top: 1rem;
	}
	.pay-content .pay-num .num{
		font-size: 2.5rem;
		color: #FF6161;
	}
	.pay-content .pay-num .per{
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	.pay-content .pay-type{
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 1rem;
		color: #7b7b7b;
		padding: 0.5rem 1rem;
		border-top: 1px solid #f3f3f3;
		border-bottom: 1px solid #f3f3f3;
	}
	.pay-inner .pay-btns{
		padding: 1.5rem 1rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.pay-inner .pay-btns button{
		width: 45%;
		height: 2.3rem;
		border-radius: 3px;
		outline: 0;
	}
	.pay-inner .pay-btns button.cancel{
		border: 1px solid #f3f3f3;
		color: #7b7b7b;
		background: none;
	}
	.pay-inner .pay-btns button.sure{
		color: #fff;
		background:linear-gradient(90deg,rgba(84,21,249,0.7) 0%,rgba(84,21,249,0.3) 100%);
		border: 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/Finds/AppointAddGiftCul.vue